<template>
    <ElTree
        ref="tree"
        :current-node-key="orgId"
        :load="loadNode"
        :props="{ label: 'name', isLeaf: 'leaf' }"
        class="login-org-tree"
        highlight-current
        lazy
        node-key="id"
        @node-click="handleClick"
    />
</template>

<script>
    import { ElTree } from 'element-plus';
    import { load } from '@/utils/Http';

    export default {
        name: 'LazyTree',
        components: {
            ElTree,
        },
        props: {
            orgId: {
                type: Number,
                required: true,
            },
            orgName: {
                type: String,
                required: true,
            },
        },
        emits: ['change', 'click'],
        methods: {
            loadNode(node, resolve) {
                if (node.level === 0) {
                    return resolve([{ name: this.orgName, id: this.orgId, leaf: false }]);
                } else {
                    load('organisation/tree', { orgId: node.data.id }, (response) => {
                        this.$emit('change', response.rights);
                        resolve(response.organisations);
                    });
                }
            },
            handleClick() {
                this.$emit('click', {
                    id: this.$refs.tree.getCurrentKey(),
                    name: this.$refs.tree.getCurrentNode().name,
                });
            },
        },
    };
</script>
